import { render, staticRenderFns } from "./emotion_list.vue?vue&type=template&id=0463162b&scoped=true&"
import script from "./emotion_list.vue?vue&type=script&lang=js&"
export * from "./emotion_list.vue?vue&type=script&lang=js&"
import style0 from "./emotion_list.vue?vue&type=style&index=0&id=0463162b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463162b",
  null
  
)

export default component.exports